import { render, staticRenderFns } from "./CategoryModal.vue?vue&type=template&id=6a991ce6"
import script from "./CategoryModal.vue?vue&type=script&lang=js"
export * from "./CategoryModal.vue?vue&type=script&lang=js"
import style0 from "./CategoryModal.vue?vue&type=style&index=0&id=6a991ce6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports